import { Translate } from 'next-translate';

import { IncumbentOption } from './getIncumbentOptions';

export const getIncumbentOptionLabel = (t: Translate, incumbentOptions: IncumbentOption[], value?: string | null): string => {
  const selected = incumbentOptions.find(option => String(option.value) === String(value));

  if (selected?.label?.length) {
    return selected.label;
  }
  return t('general.none');
};
